// extracted by mini-css-extract-plugin
export default {"btn":"HoldButton_btn__hywRM","hover":"HoldButton_hover__wr2ZL"};